import React, { useState, useEffect } from "react";
import logoWhite from "../../assets/logo-white.png";
import Select from "react-select";

import "./header.css";

const Header = ({
  allPois,
  destinationPoi,
  sourcePoi,
  setSource, 
  setDestination,
  onTakeMeThere,
  selectedDestination,
  isMobile,
  setIsShowSearchResult,
  setActiveSearch,
}) => {
  const [isSourceChange, setIsSourceChange] = useState(false);
  const [isDestinationChange, setIsDestinationChange] = useState(false);
  const [destinationValue, setDestinationValue] = useState(null)
  const [sourceValue, setSourceValue] = useState(null)

  const onDestinationChange = (e) => {
    setDestination(e.target.value);
    setIsDestinationChange(true)
    setActiveSearch('destination')
    setDestinationValue(e.target.value)
  }

  const onSourceChange = (e) => {
    setSource(e.target.value);
    setIsSourceChange(true)
    setActiveSearch('source')
    setSourceValue(e.target.value)
  }

  // const pois = allPois.map(poi => {
  //   return { id: poi.id, label: poi.name };
  // });

  // const onSelectChanged = (value, type) => {
  //   console.log(value, type);
  //   if (type === "source") {
  //     setSource(value);
  //     setIsSourceChange(true);
  //   } else {
  //     setDestination(value);
  //     setIsDestinationChange(true);
  //   }
  // };

  return (
    <div className="container">
      <div className="p-2">
        {isMobile ? (
          <img src={logoWhite} alt="logo" className="logo pb-1" />
        ) : (
          <img src={logoWhite} alt="logo" className="pb-1" />
        )}
      </div>
      {isDestinationChange || destinationPoi ? (
        <div className="m-1">
          <input
            className={isMobile ? "input is-link is-small" : "input is-link"}
            type="text"
            placeholder="Where are you?"
            onChange={onSourceChange}
            value={sourcePoi ? sourcePoi.name : sourceValue}
            onClick={() => setIsShowSearchResult(true)}
          ></input>
        </div>
      ) : null}
      <div className="mb-1 ml-1 mr-1">
        <input
          className={isMobile ? "input is-link is-small" : "input is-link"}
          type="text"
          placeholder="Where do you want to go?"
          onChange={onDestinationChange}
          value={destinationPoi ? destinationPoi.name : destinationValue}
          onClick={() => setIsShowSearchResult(true)}
        ></input>
      </div>
      {isSourceChange || sourcePoi ? (
        <button className="button take is-small" onClick={() => onTakeMeThere()}>
          Take Me There
        </button>
      ) : null}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header/Header.js